module.exports = __webpack_public_path__ + "static/media/Terrakion_gaussian2.d1c187ba.png";